import React from "react"
import { InputMask as PrimeInputMask } from "primereact/inputmask"
/**
 * @param {import("primereact/inputtext").InputTextProps} props
 * @returns
 */
const InputMask = React.forwardRef(
  /**
   * @param {import("primereact/inputtext").inputtext} props
   * @param {React.Ref<HTMLDivElement>} ref
   * @returns {JSX.Element}
   */
  (props, ref) => {
    return <PrimeInputMask ref={ref} {...props} />
  }
)

export default InputMask
